import { FormControl, Grid, MenuItem, Select } from "@material-ui/core";
import { useMemo, useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { CombinedState } from "redux";
import en from "../../../lang/en-us";
import { ListCardsFund } from "../../../lib/ListCards";
import {
  getAmcDetails,
  getPortfolio,
} from "../../../redux-store/actions/portfolio";
import { RootStateType } from "../../../redux-store/reducers";
import {
  IsAllow,
  PORTFOLIO_DATA_RESPONSE,
  SCHEMES_RESPONSE,
  SUMMARY_INFO_RESPONSE,
} from "../../../redux-store/types/portfolio";
import { formatAsIndianCurrency } from "../../../utils/currency";
import HomePageCard from "../../home/card";
import { decimalFix } from "./utils";
import { logo } from "../../../logo/logos";
import { useHistory } from "react-router";
const { dashboard, common } = en;

const SORT_TYPES = [
  en.dashboard.portfolioDetails.sortbyList.gainLoss,
  en.dashboard.portfolioDetails.sortbyList.marketValue,
  // en.dashboard.portfolioDetails.sortbyList.atoz
];
const AXIS_FUND = "128";
const UTI_FUND = "108";

const StaticAdInfo: any = {
  [AXIS_FUND]: {
    leftBanner: "axis-bottom-ad.svg",
    bottomBanner: "axis-slide-ad.svg",
  },
  [UTI_FUND]: {
    leftBanner: "uti-bottom-ad.svg",
    bottomBanner: "uti-slide-ad.svg",
  },
};

function PortfolioSchemes(props: any) {
  const schemeDetails: {
    schemes: SCHEMES_RESPONSE[];
    summary: SUMMARY_INFO_RESPONSE;
  } = props.amcDetails || {};
  const { schemes = [], summary = {} } = schemeDetails;
  const { params = {} } = props.match;
  const { type, assetType } = props.location.state || {};
  const { amc } = params;
  const [selectedFolio, setFolio] = useState<string | number | any>("");
  const [sortBy, setSortBy] = useState<any>("NONE");
  const history = useHistory();

  const folios: number[] = useMemo(() => {
    let folios = schemes.reduce((prev: any, curr: SCHEMES_RESPONSE) => {
      if (!prev.includes(curr.folio)) {
        prev = [...prev, curr.folio];
      }
      return prev;
    }, []);
    return folios;
  }, [schemes]);

  useEffect(() => {
    setFolio(folios[0]);
  }, [schemes]);

  // useEffect(() => {
  //   if (!type || !amc) {
  //     props.history.push("/");
  //   }
  // }, []);

  const {
    amcName = "",
    costValue = 0,
    currentMktValue = 0,
    gainLoss = 0,
    gainLossPercentage = 0,
  }: any = summary;

  useEffect(() => {
    async function fetchPortfolio() {
      const { pan = "", pekrn = "", mobile = "", reqId = "" } = props;
      await props.getPortfolio({
        pan,
        pekrn,
        mobile,
        reqId,
      });
    }
    if (!Object.keys(props.portfolios).length || history.action === "POP") {
      fetchPortfolio();
    }
  }, []);

  useEffect(() => {
    if (Object.keys(props.portfolios).length) {
      props.getAmcDetails({ amc, type, assetType });
    }
  }, [props.portfolios]);

  const schemeInfo = useMemo(() => {
    let data = [...schemes];
    if (sortBy === 0) {
      data.sort((first: SCHEMES_RESPONSE, second: SCHEMES_RESPONSE) => {
        return second.gainLossPercentage - first.gainLossPercentage;
      });
      // data.sort((first: SCHEMES_RESPONSE, second: SCHEMES_RESPONSE) => {
      //   let holding1 = decimalFix(
      //     (Number(first.costValue) * 100) / Number(summary.costValue)
      //   );
      //   let holding2 = decimalFix(
      //     (Number(second.costValue) * 100) / Number(summary.costValue)
      //   );
      //   return holding2 - holding1;
      // });
    } else if (sortBy === 1) {
      data.sort((first: SCHEMES_RESPONSE, second: SCHEMES_RESPONSE) => {
        return Number(second.costValue) - Number(first.costValue);
      });
    } else {
    }
    return data;
  }, [sortBy, schemes]);

  return (
    <div className="portfolio-schemes-page">
      <HomePageCard className="db-banner db-portfolio">
        <div>
          <h3>
            <a
              onClick={() => props.history.push("/portal/portfolio")}
              className="backbtn"
            >
              <img src="/images/left-arrow-white.svg" alt="icon" />
            </a>
            <div className="list-cards-image">
              <img
                src={`/images/client-logos/${logo[amc]}.png`}
                alt=""
                className="list-logo"
              />
            </div>
            {amcName}
          </h3>
          <div className="db-portfolio-bottom">
            <div className="db-portfolio-info">
              <h6>{dashboard.dbPortfolio.investedvalue}</h6>
              <p>{formatAsIndianCurrency(Number(costValue))}</p>
            </div>
            <div className="db-portfolio-info">
              <h6>{dashboard.dbPortfolio.marketvalue}</h6>
              <p>{formatAsIndianCurrency(Number(currentMktValue))}</p>
            </div>
            <div className="db-portfolio-info">
              <h6>{dashboard.dbPortfolio.gainLoss}</h6>
              <p>
                {formatAsIndianCurrency(Number(gainLoss))}
                <span>
                  <img
                    src={
                      Number(gainLossPercentage) >= 0
                        ? "/images/profit.svg"
                        : "/images/loss.svg"
                    }
                  />
                  {decimalFix(gainLossPercentage)}%
                </span>
              </p>
            </div>
          </div>
        </div>
      </HomePageCard>
      <div className="portfolio-schemes-page-bottom">
        <Grid
          container
          spacing={0}
          xs={12}
          className="db-grid-boxes portfolio-schemes-grid"
        >
          {/* <Grid item xs={12} md={8}> */}
          <Grid item xs={12}>
            <div className="portfolio-scheme-maxwidth">
              <FormControl className="portfolio-folio-drpdwn ">
                <p>{dashboard.portfolioSchemes.folio} - </p>
                &nbsp;
                <Select
                  labelId="folio-dropdown-label"
                  id="folio-dropdown"
                  defaultValue={selectedFolio}
                  value={selectedFolio}
                  onChange={({ target: { value } }) => setFolio(value)}
                >
                  {folios.map((folio: number) => (
                    <MenuItem key={folio} value={folio}>
                      {folio}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div className="portfolio-details-filter">
                <div className="portfolio-details-sortby">
                  <p>{en.dashboard.portfolioDetails.sortby} :</p>
                  <FormControl variant="filled">
                    <Select
                      labelId="portfolio-sortby-label"
                      id="portfolio-sortby"
                      onChange={({ target: { value } }) => setSortBy(value)}
                      value={sortBy}
                    >
                      <MenuItem value="NONE">
                        {en.dashboard.portfolioDetails.select}
                      </MenuItem>
                      {SORT_TYPES.map((type: string, index: number) => (
                        <MenuItem key={index} value={index}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>
            <div className="list-cards list-cards-fund portfolio-scheme-maxwidth">
              {schemeInfo
                .filter((scheme) => scheme.folio === selectedFolio)
                .map((ele: SCHEMES_RESPONSE, index: number) => (
                  <ListCardsFund
                    isin={ele.isin}
                    scheme={ele.schemeName}
                    amcDetails={ele}
                    xirr={5.5}
                    investedValue={ele.costValue}
                    marketValue={ele.currentMktValue}
                    gainLoss={ele.gainLoss}
                    gainLossPercent={ele.gainLossPercentage}
                    balanceUnits={ele.closingBalance}
                    isDemat={ele.isDemat === IsAllow.YES}
                    assetType={ele.assetType}
                    schemeType={ele.schemeType}
                    navDate={ele.navDate}
                    key={index}
                    nav={ele.nav}
                  />
                ))}
            </div>
            {/* <div className="portfolio-left-ad">
              <img
                src={`/images/${
                  StaticAdInfo[amc]?.leftBanner || "portfolio-scheme-ad.png"
                }`}
                alt="icon"
              />
            </div> */}
          </Grid>
          {/* <Grid item xs={12} md={4} className="portfolio-ads-section">
            <div className="portfolio-ads">
              <div className="portfolio-ads-info">
                <a>
                  <img
                    src={`/images/${
                      StaticAdInfo[amc]?.bottomBanner || "hdfc-slide-ad.svg"
                    }`}
                    alt="icon"
                  />
                </a>
              </div>
            </div>
            <div className="popular-schemes">
              <h3> {dashboard.portfolioSchemes.popularSchemes.heading}</h3>
              <div className="popular-schemes-slider">
                {(!!StaticAdInfo[amc] &&
                schemeInfo.filter((scheme) => scheme.folio === selectedFolio)
                  .length
                  ? schemeInfo.filter(
                      (scheme) => scheme.folio === selectedFolio
                    ).slice(0,2)
                  : new Array(2).fill({})
                ).map((scheme, index) => (
                  <div key={index} className="popular-schemes-single">
                    <h4>
                      {scheme?.schemeName ||
                        `HDFC Large Cap Fund Direct- Growth`}
                    </h4>
                    <p>
                      Large cap funds provides inflation beating growth over the
                      long term and is suitable for investment.
                    </p>
                    <div className="amount">
                      <div>
                        <p>{dashboard.portfolioSchemes.minimumAmount}</p>
                        <span>₹ 5,000</span>
                      </div>
                      <div>
                        <p>{dashboard.portfolioSchemes.cagr}</p>
                        <span className="profit">16.28%</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Grid> */}
        </Grid>
      </div>
    </div>
  );
}

export default connect(
  ({ authReducer, portfolio }: CombinedState<RootStateType>) => ({
    ...portfolio,
    ...authReducer,
  }),
  { getPortfolio, getAmcDetails }
)(PortfolioSchemes);
